import React, { useEffect } from "react";
import Requester from "shared/Requester";

import AdminRequester from "shared/AdminRequester";
import MedusaRequester from "shared/Requester-Medusa";
import FileRequester from "shared/FileRequester";
import NiceModal from "@ebay/nice-modal-react";
import AuthProvider from "providers/AuthProvider";
import BrowserEventProvider from "providers/BrowserEventProvider";
import RootRouter from "router/RootRouter";
import PapagoRequester from "shared/PapagoRequester";
import { ToastContainer } from "react-toastify";
import style from "./App.module.css";
import { useSelector } from "react-redux";
import Loading from "modals/base/Loading";
import AdminFileRequester from "shared/AdminFileRequester";
import SocketRequester from "shared/SocketRequest";
import StoreRequester from "shared/StoreRequester";
import RegionProvider from "providers/RegionProvider";
import { PartnerLinkHandler } from "shared/utils/PartnerLinkHandler";
import CacheBuster from 'react-cache-buster';
import CacheLoaing from "components/CacheLoaing";
import packageJson from '../package.json';

export const adminRequester = new AdminRequester();
export const adminFileRequester = new AdminFileRequester();
export const socketRequester = new SocketRequester();
export const storeRequester = new StoreRequester();

// to-do 아래 삭제 예정
export const requester = new Requester();
export const fileRequester = new FileRequester();
export const papagoRequester = new PapagoRequester();
export const medusaRequester = new MedusaRequester();
function App() {
  // to-do 접속 기록 남기기

  const { isLoading } = useSelector((state) => ({
    isLoading: state.history.isLoading,
  }));

  useEffect(() => {
    const disableScrollRestoration = () => {
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
    };

    disableScrollRestoration();

    return () => {
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "auto";
      }
    };
  }, []);

  const isProduction = process.env.NODE_ENV === 'production';
  const appVersion = packageJson.version;

  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<CacheLoaing />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
      <BrowserEventProvider>
        <div className={style.toast}>
          <ToastContainer />
        </div>
        <Loading isLoading={isLoading} />
        <PartnerLinkHandler />
        <RegionProvider>
          <AuthProvider>
            <NiceModal.Provider>
              <RootRouter />
            </NiceModal.Provider>
          </AuthProvider>
        </RegionProvider>
      </BrowserEventProvider>
    </CacheBuster>
  );
}

export default App;
